<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('orders.pendingToBranchOrdersTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            deliver_to_branch: 'deliver_to_branch',
            generate_qr_code: 'pending_to_branch_generate_qrcode',
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addSendToBranchButton="true"
          :openSendToBranchModal="openSendToBranchModal"
          :addSendAllToBranchButton="true"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :sendAllToPendingToBranch="sendAllToPendingToBranch"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addQrCodeGenerateButton="true"
          :openGenerateQrCodeModal="openGenerateQrCodeModal"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :defaultHideCol="defaultHideCol"
          :storageKey="'cols_pendingToBranchOrder_v2'"
          :resultsVersion="resultsVersion"
          :warehouseFilterItems="warehouses"
          :warehouseFilterChange="handleWarehouseFilter"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity: 0"
            ></span>
          </div>

          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="
                  qrCodeValues.find((x) => x[0] == r.order_id)
                    ? 'background-color: #FFF9C4'
                    : ((r.item_weight === 0 || r.item_weight == null) || (Number(r.is_ship_only) === 1)) && !r.order_invoice_id_fk
                    ? 'background-color: #ee7272'
                    : ''
                "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[
                      r.order_id,
                      r.full_name,
                      r.phone_number,
                      r.user_id,
                      r.theOrderID,
                      r.is_ship_only,
                      r.credit,
                      r.product_name,
                    ]"
                    v-model="qrCodeValues"
                  />
                  <!-- r.deliver_branch_name,
                      r.deliver_branch_id_fk, -->
                </td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-users :orderData="r" />
                </td>
                <!-- QR -->
                <td><i v-if="r.qrcode" class="fa fa-qrcode" aria-hidden="true"></i> {{ r.qrcode || '—' }}</td>
                <!-- Item Code -->
                <td>
                  <span v-if="r.qrcode == null || r.qrcode == ''">{{ r.theOrderID }}</span>
                  <span v-else>
                    <i class="fa fa-qrcode" aria-hidden="true"></i> {{ r.theOrderID }}
                    <span v-if="r.track_number" style="display:block; font-size:11px; color:#555;">{{ r.track_number }}</span>
                  </span>
                </td>
                <!-- Invoice No. -->
                <td>{{ r.last_order_invoice || '—' }}</td>
                <!-- Customer ID -->
                <td>{{ r.customer_id_fk || '—' }}</td>
                <!-- Phone Number -->
                <td>{{ r.phone_number || '—' }}</td>
                <!-- Customer -->
                <td class="ws-nowrap">
                  <customer-device-icon :orderSource="r.order_source" />
                  <img v-if="r.profile_image" :src="r.profile_image && r.profile_image.startsWith('http') ? r.profile_image : `${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span class="customer-name-stack">
                    <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                      {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                    </span>
                    <span v-else>{{ r.full_name }}</span>
                    <span v-if="r.phone_number" class="customer-phone-line">{{ r.phone_number }}</span>
                    <span v-if="r.phone_number_2" class="customer-phone-line">{{ r.phone_number_2 }}</span>
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <!-- Item Name -->
                <td>{{ r.product_name ? r.product_name.substr(0, 35) + (r.product_name.length > 35 ? '...' : '') : '—' }}</td>
                <!-- Brand -->
                <td>{{ r.brand }}</td>
                <!-- URL -->
                <td style="text-align:center;">
                  <a v-if="r.product_url" :href="r.product_url" target="_blank" rel="noopener noreferrer" style="color:#01579B;">
                    <i class="material-icons" style="font-size:20px; vertical-align:middle;">link</i>
                  </a>
                  <span v-else style="color:#bbb;">—</span>
                </td>
                <!-- Image -->
                <td style="text-align:center">
                  <img v-if="r.image" :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`" width="130" style="border-radius:4px; cursor:pointer;" @click="lightboxImage = r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`; lightboxOpen = true" />
                  <span v-else style="color:#bbb; font-size:11px;">—</span>
                </td>
                <!-- Date & Time -->
                <td style="min-width: 130px" class="hover-container">
                  <view-order-dates :orderData="r" />
                </td>
                <!-- Status -->
                <td>
                  <span style="display:inline-block; padding:2px 8px; border-radius:12px; font-size:12px; font-weight:500; background:#8B82FF; color:#FFFFFF;">{{ $_status_label(r.status) }}</span>
                </td>
                <!-- Warehouse -->
                <td>{{ r.country || '—' }}</td>
                <!-- Type -->
                <td>{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '—' }}</td>
                <!-- Summary -->
                <td class="combined-cell-td">
                  <div class="combined-cell">
                    <div><span class="combined-cell-label">{{ $t('columns.price') }}:</span> {{ r.item_price ? '$' + r.item_price : '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.shipping') }}:</span> {{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.total') }}:</span> {{ r.total_amount ? '$' + r.total_amount : '—' }}</div>
                    <div class="combined-cell-divider"></div>
                    <div><span class="combined-cell-label">{{ $t('columns.qty') }}:</span> {{ r.quantity || '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.size') }}:</span> {{ r.size || '—' }}</div>
                  </div>
                </td>
                <!-- Shiponly -->
                <td>{{ r.is_ship_only == 1 ? $t('common.yes') : $t('common.no') }}</td>
                <!-- Purchase Note -->
                <td>{{ r.purchase_note || '—' }}</td>
                <!-- Price -->
                <td>{{ r.item_price ? '$' + r.item_price : '—' }}</td>
                <!-- Shipping -->
                <td>{{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</td>
                <!-- Total -->
                <td>{{ r.total_amount ? '$' + r.total_amount : '—' }}</td>
                <!-- Size -->
                <td>{{ r.size || '—' }}</td>
                <!-- Qty -->
                <td>{{ r.quantity || '—' }}</td>
                <!-- Bank (hidden) -->
                <!-- <td>{{ r.bank_name || '—' }}</td> -->
                <td
                  v-if="$_has_perm('view_order_detail')"
                  class="rtl-pl-10 rtl-pr-5"
                >
                  <a
                    style="color: #01579b"
                    :tooltip="$t('orders.viewDetails')"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('deliver_to_branch')"
                  class="rtl-pl-0 rtl-pr-10"
                >
                  <a
                    style="color: #5D4037"
                    :tooltip="$t('orders.deliverToBranchTooltip')"
                    @click="deliverToBranch(r)"
                  >
                    <i class="material-icons">local_shipping</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  > {{ $t('common.noResultsFound') }} </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <div v-if="isMobile">
            <div
              v-for="(r, index) in apiResults"
              :key="r.order_id"
              class="moc-container"
            >
              <div class="moc-card">
                <div class="moc-header" :style="qrCodeValues.find(x => x[0] == r.order_id) ? 'border: 2px solid #FBC02D;' : ''">
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID, r.is_ship_only, r.credit, r.product_name]"
                    v-model="qrCodeValues"
                    class="rtl-mr-8"
                  />
                  <span class="moc-item-code">{{ r.theOrderID }}<span v-if="r.track_number" style="font-size:10px; color:#555; font-weight:400;"> · {{ r.track_number }}</span></span>
                  <span class="moc-status-badge" style="background:#8B82FF; color:#FFFFFF;">{{ $_status_label(r.status) }}</span>
                </div>
                <div class="moc-body">
                  <!-- QR -->
                  <div class="moc-row" v-if="r.qrcode">
                    <span class="moc-label">{{ $t('columns.qr') }}</span>
                    <span class="moc-value"><i class="fa fa-qrcode" aria-hidden="true"></i> {{ r.qrcode }}</span>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <div>
                      <span class="moc-label">{{ $t('columns.invoiceNo') }}</span>
                      <span class="moc-value">{{ r.last_order_invoice || '—' }}</span>
                    </div>
                    <div>
                      <span class="moc-label">{{ $t('columns.customerId') }}</span>
                      <span class="moc-value">{{ r.customer_id_fk || '—' }}</span>
                    </div>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <span class="moc-label">{{ $t('columns.phone') }}</span>
                    <span class="moc-value">{{ r.phone_number || '—' }}</span>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <span class="moc-label">{{ $t('columns.customer') }}</span>
                    <span class="moc-value">{{ r.full_name }}</span>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <span class="moc-label">{{ $t('columns.item') }}</span>
                    <span class="moc-value">{{ r.product_name ? r.product_name.substr(0, 35) + (r.product_name.length > 35 ? '...' : '') : '—' }}</span>
                  </div>
                  <div class="moc-row moc-row--2col" v-if="r.brand">
                    <span class="moc-label">{{ $t('columns.brand') }}</span>
                    <span class="moc-value">{{ r.brand }}</span>
                  </div>
                  <div class="moc-row moc-row--2col" v-if="r.product_url">
                    <span class="moc-label">{{ $t('columns.url') }}</span>
                    <span class="moc-value">
                      <a :href="r.product_url" target="_blank" rel="noopener noreferrer" style="color:#01579B;">
                        <i class="material-icons" style="font-size:20px; vertical-align:middle;">link</i>
                      </a>
                    </span>
                  </div>
                  <div class="moc-row" v-if="r.image">
                    <span class="moc-label">{{ $t('columns.image') }}</span>
                    <span class="moc-value">
                      <img
                        :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`"
                        style="width:80px; height:80px; object-fit:cover; border-radius:4px; cursor:pointer;"
                        @click="lightboxImage = r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`; lightboxOpen = true"
                      />
                    </span>
                  </div>
                  <div class="moc-row">
                    <span class="moc-label">{{ $t('columns.dateTime') }}</span>
                    <span class="moc-value"><view-order-dates :orderData="r" /></span>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <div>
                      <span class="moc-label">{{ $t('columns.warehouse') }}</span>
                      <span class="moc-value">{{ r.country || '—' }}</span>
                    </div>
                    <div>
                      <span class="moc-label">{{ $t('columns.type') }}</span>
                      <span class="moc-value">{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '—' }}</span>
                    </div>
                  </div>
                  <div class="moc-row moc-row--3col">
                    <div>
                      <span class="moc-label">{{ $t('columns.price') }}</span>
                      <span class="moc-value">{{ r.item_price ? '$' + r.item_price : '—' }}</span>
                    </div>
                    <div>
                      <span class="moc-label">{{ $t('columns.shipping') }}</span>
                      <span class="moc-value">{{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</span>
                    </div>
                    <div>
                      <span class="moc-label">{{ $t('columns.total') }}</span>
                      <span class="moc-value">{{ r.total_amount ? '$' + r.total_amount : '—' }}</span>
                    </div>
                  </div>
                  <div class="moc-row moc-row--2col" v-if="r.size">
                    <span class="moc-label">{{ $t('columns.size') }}</span>
                    <span class="moc-value">{{ r.size }}</span>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <span class="moc-label">{{ $t('columns.shipOnly') }}</span>
                    <span class="moc-value">{{ r.is_ship_only == 1 ? $t('common.yes') : $t('common.no') }}</span>
                  </div>
                  <div v-if="r.purchase_note" class="moc-row moc-row--2col">
                    <span class="moc-label">{{ $t('columns.purchaseNote') }}</span>
                    <span class="moc-value">{{ r.purchase_note }}</span>
                  </div>
                </div>
                <div class="moc-actions">
                  <a
                    v-if="$_has_perm('view_order_detail')"
                    style="color:#01579B"
                    :tooltip="$t('orders.viewDetails')"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                  <a
                    v-if="$_has_perm('deliver_to_branch')"
                    style="color:#5D4037"
                    :tooltip="$t('orders.deliverToBranchTooltip')"
                    @click="deliverToBranch(r)"
                  >
                    <i class="material-icons">local_shipping</i>
                  </a>
                </div>
              </div>
            </div>
            <v-alert type="error" :value="alertValue">{{ $t('common.noResultsFound') }}</v-alert>
          </div>

          <v-dialog v-model="lightboxOpen" max-width="600">
            <v-card v-if="lightboxImage">
              <v-card-text style="padding:0; text-align:center; background:#000;">
                <img :src="lightboxImage" style="max-width:100%; max-height:80vh; object-fit:contain;" />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="lightboxOpen = false">{{ $t('common.close') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <create-qr-code
            :openGenerateQrCodeModal="openGenerateQrCodeModal"
            :generateQrCodeModal="generateQrCodeModal"
            :closeGenerateQrCodeModal="closeGenerateQrCodeModal"
            :qrCodeValues="qrCodeValues"
            :generateQrCode="generateQrCode"
            :getResults="getResults"
          >
          </create-qr-code>

          <send-to-branch
            :sendToBranchData="sendToBranchData"
            :sendToBranch="sendToBranch"
            :sendToBranchModal="sendToBranchModal"
            :openSendToBranchModal="openSendToBranchModal"
            :closeSendToBranchModal="closeSendToBranchModal"
            :saveWhatsAppTemplate="saveWhatsAppTemplate"
          >
          </send-to-branch>

          <v-dialog v-model="deliverToBranchModal" persistent max-width="650px">
            <v-card>
              <v-card-title>
                <v-flex xs11 sm11 md11><span class="headline">{{ $t('whatsappTemplate.deliverToBranchTitle') }}</span></v-flex>
                <v-flex xs1 sm1 md1>
                  <v-btn flat @click="closeDeliverToBranchModal" class="close"><span aria-hidden="true">
                  <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
                </span></v-btn>
                </v-flex>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div class="d-flex align-center">
                        <img
                          src="../../assets/images/whatsapp.png"
                          style="width: 32px; margin-top: -10px"
                          alt="whatsapp"
                          class="align-self-center mr-2"
                        >
                        <v-checkbox
                          style="padding: 0px;"
                          :label="$t('whatsappTemplate.sendWhatsappMessageLabel')"
                          v-model="deliverToBranchData.send_sms"
                          color="indigo"
                        ></v-checkbox>
                      </div>
                    </v-flex>
                    <v-flex xs12 v-if="deliverToBranchData.send_sms" style="margin-top: 10px;">
                      <label
                        for="englishMessage"
                        style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
                      >
                        {{ $t('whatsappTemplate.englishMessageLabel') }}
                      </label>
                      <textarea
                        v-model="deliverToBranchData.englishMessage"
                        class="form-control"
                        style="border-bottom: 1px solid blue; font-size: 1.5rem; width: 50%; max-width: 100%; box-sizing: border-box;"
                        rows="4"
                      />
                    </v-flex>
                    <v-flex xs12 v-if="deliverToBranchData.send_sms" style="margin-top: 10px;">
                      <label
                        for="arabicMessage"
                        style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
                      >
                        {{ $t('whatsappTemplate.arabicMessageLabel') }}
                      </label>
                      <textarea
                        v-model="deliverToBranchData.arabicMessage"
                        class="form-control"
                        style="border-bottom: 1px solid blue; font-size: 1.5rem; direction: rtl; width: 50%; max-width: 100%; box-sizing: border-box;"
                        rows="4"
                      />
                    </v-flex>
                    <v-flex xs12 v-if="deliverToBranchData.send_sms" style="margin-top: 10px;">
                      <label
                        for="kurdishMessage"
                        style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
                      >
                        {{ $t('whatsappTemplate.kurdishMessageLabel') }}
                      </label>
                      <textarea
                        v-model="deliverToBranchData.kurdishMessage"
                        class="form-control"
                        style="border-bottom: 1px solid blue; font-size: 1.5rem; width: 50%; max-width: 100%; box-sizing: border-box;"
                        rows="4"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn class="buttonPadding" @click="saveWhatsAppTemplate" outline color="primary">{{ $t('whatsappTemplate.saveAsDefaultTemplateButton') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="buttonPadding" @click="closeDeliverToBranchModal">{{ $t('common.cancel') }}</v-btn>
                <v-btn class="buttonPadding" @click="deliverToBranchSubmit" color="success">{{ $t('common.ok') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="sendAllToBranchModal" persistent max-width="650px">
            <v-card>
              <v-card-title>
                <v-flex xs11 sm11 md11><span class="headline">{{ $t('whatsappTemplate.sendAllToBranchTitle') }}</span></v-flex>
                <v-flex xs1 sm1 md1>
                  <v-btn flat @click="closeSendAllToBranchModal" class="close"><span aria-hidden="true">
                  <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
                </span></v-btn>
                </v-flex>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div class="d-flex align-center">
                        <img
                          src="../../assets/images/whatsapp.png"
                          style="width: 32px; margin-top: -10px"
                          alt="whatsapp"
                          class="align-self-center mr-2"
                        >
                        <v-checkbox
                          style="padding: 0px;"
                          :label="$t('whatsappTemplate.sendWhatsappMessageLabel')"
                          v-model="sendAllToBranchData.send_sms"
                          color="indigo"
                        ></v-checkbox>
                      </div>
                    </v-flex>
                    <v-flex xs12 v-if="sendAllToBranchData.send_sms" style="margin-top: 10px;">
                      <label
                        for="englishMessage"
                        style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
                      >
                        {{ $t('whatsappTemplate.englishMessageLabel') }}
                      </label>
                      <textarea
                        v-model="sendAllToBranchData.englishMessage"
                        class="form-control"
                        style="border-bottom: 1px solid blue; font-size: 1.5rem; width: 50%; max-width: 100%; box-sizing: border-box;"
                        rows="4"
                      />
                    </v-flex>
                    <v-flex xs12 v-if="sendAllToBranchData.send_sms" style="margin-top: 10px;">
                      <label
                        for="arabicMessage"
                        style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
                      >
                        {{ $t('whatsappTemplate.arabicMessageLabel') }}
                      </label>
                      <textarea
                        v-model="sendAllToBranchData.arabicMessage"
                        class="form-control"
                        style="border-bottom: 1px solid blue; font-size: 1.5rem; direction: rtl; width: 50%; max-width: 100%; box-sizing: border-box;"
                        rows="4"
                      />
                    </v-flex>
                    <v-flex xs12 v-if="sendAllToBranchData.send_sms" style="margin-top: 10px;">
                      <label
                        for="kurdishMessage"
                        style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
                      >
                        {{ $t('whatsappTemplate.kurdishMessageLabel') }}
                      </label>
                      <textarea
                        v-model="sendAllToBranchData.kurdishMessage"
                        class="form-control"
                        style="border-bottom: 1px solid blue; font-size: 1.5rem; width: 50%; max-width: 100%; box-sizing: border-box;"
                        rows="4"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn class="buttonPadding" @click="saveWhatsAppTemplate" outline color="primary">{{ $t('whatsappTemplate.saveAsDefaultTemplateButton') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="buttonPadding" @click="closeSendAllToBranchModal">{{ $t('common.cancel') }}</v-btn>
                <v-btn class="buttonPadding" @click="sendAllToBranchSubmit" color="success">{{ $t('common.ok') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import axios from 'axios'
import swal from 'sweetalert'
import createQrCode from './createQrCode.vue'
import sendToBranch from './sendToBranch.vue'
import statusHelpers from '../mixins/statusHelpers'

export default {
  mixins: [statusHelpers],
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'create-qr-code': createQrCode,
    'send-to-branch': sendToBranch
  },

  mounted() {
    this.$_fetch_statuses()
    this.getWarehouses()
    this.perPageFix()
    this.fetchWhatsAppTemplate()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: this.$t('columns.checkBoxColumn'), value: '1' },
      { label: this.$t('common.user'), text: this.$t('common.user'), value: '2', sortable: false, searchable: false, name: 'user' },
      { label: this.$t('columns.qr'), text: this.$t('columns.qr'), value: '3', sortable: true, searchable: true, name: 'qrcode' },
      // Track Number is displayed inline under Item Code (not a separate column)
      { label: this.$t('columns.itemCode'), text: this.$t('columns.itemCode'), value: '4', sortable: true, searchable: true, name: 'theOrderID' },
      { label: this.$t('columns.invoiceNo'), text: this.$t('columns.invoiceNo'), value: '5', sortable: true, searchable: false, name: 'last_order_invoice' },
      { label: this.$t('columns.customerId'), text: this.$t('columns.customerId'), value: '6', sortable: true, searchable: true, name: 'customer_id_fk' },
      { label: this.$t('columns.phoneNumber'), text: this.$t('columns.phoneNumber'), value: '7', sortable: true, searchable: true, name: 'phone_number' },
      { label: this.$t('columns.customer'), text: this.$t('columns.customer'), value: '8', sortable: true, searchable: true, name: 'full_name' },
      { label: this.$t('columns.itemName'), text: this.$t('columns.itemName'), value: '9', sortable: true, searchable: true, name: 'product_name' },
      { label: this.$t('columns.brand'), text: this.$t('columns.brand'), value: '10', sortable: true, searchable: true, name: 'brand' },
      { label: this.$t('columns.url'), text: this.$t('columns.url'), value: '11', sortable: false, searchable: false, name: 'product_url' },
      { label: this.$t('columns.image'), text: this.$t('columns.image'), value: '12', sortable: false, searchable: false, name: 'image' },
      { label: this.$t('columns.dateTime'), text: this.$t('columns.dateTime'), value: '13', sortable: true, searchable: false, name: 'updated_at' },
      { label: this.$t('columns.status'), text: this.$t('columns.status'), value: '14', sortable: true, searchable: true, name: 'status' },
      { label: this.$t('columns.warehouse'), text: this.$t('columns.warehouse'), value: '15', sortable: true, searchable: true, name: 'country' },
      { label: this.$t('columns.type'), text: this.$t('columns.type'), value: '16', sortable: true, searchable: true, name: 'transportation_type_obj' },
      { label: this.$t('columns.summary'), text: this.$t('columns.summary'), value: '17', sortable: false, searchable: false, name: 'price_all' },
      { label: this.$t('columns.shipOnly'), text: this.$t('columns.shipOnly'), value: '18', sortable: true, searchable: true, name: 'is_ship_only' },
      { label: this.$t('columns.purchaseNote'), text: this.$t('columns.purchaseNote'), value: '19', sortable: true, searchable: true, name: 'purchase_note' },
      { label: this.$t('columns.price'), text: this.$t('columns.price'), value: '20', sortable: true, searchable: true, name: 'item_price' },
      { label: this.$t('columns.shipping'), text: this.$t('columns.shipping'), value: '21', sortable: true, searchable: true, name: 'internal_shipping_handling' },
      { label: this.$t('columns.total'), text: this.$t('columns.total'), value: '22', sortable: true, searchable: true, name: 'total_amount' },
      { label: this.$t('columns.size'), text: this.$t('columns.size'), value: '23', sortable: true, searchable: true, name: 'size' },
      { label: this.$t('columns.qty'), text: this.$t('columns.qty'), value: '24', sortable: true, searchable: true, name: 'quantity' },
      // { label: 'Bank', text: 'Bank', value: '25', sortable: true, searchable: true, name: 'bank_name' },
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      url: 'api/pending_to_branch_order',
      archiveOrderUrl: 'api/user_delivering',
      orderDetailUrl: 'api/show_order_detail',
      deliverToBranchUrl: 'api/branch_delivering',
      sendToBranchModal: false,
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      sendToBranchData: {
        order_id: '',
        send_sms: true,
        englishMessage: '',
        arabicMessage: '',
        kurdishMessage: ''
      },
      deliverToBranchModal: false,
      deliverToBranchData: {
        id: '',
        send_sms: true,
        englishMessage: '',
        arabicMessage: '',
        kurdishMessage: ''
      },
      sendAllToBranchModal: false,
      sendAllToBranchData: {
        send_sms: true,
        englishMessage: '',
        arabicMessage: '',
        kurdishMessage: ''
      },
      savedTemplate: {
        englishMessage: '',
        arabicMessage: '',
        kurdishMessage: ''
      },
      generateQrCodeModal: false,
      qrCodeValues: [],
      filterMade: false,
      totalResult: 0,
      resultsVersion: 0,
      queryParameter: true,
      detialData: {},
      prevSearchQuery: '',
      warehouses: [],
      lightboxImage: null,
      lightboxOpen: false,
      apiResults: [],
      detailResults: [],
      orderID: {
        orders_id: [],
      },
      printData: [],
      defaultHideCol: ['7', '19', '20', '21', '22', '23', '24'],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        warehouse_id_fk: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },
  methods: {
    fetchWhatsAppTemplate() {
      const token = localStorage.getItem('access_token')
      axios
        .get('api/whatsapp-message-template', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          if (response.data.success && response.data.data) {
            const template = response.data.data
            this.savedTemplate.englishMessage = template.english_message
            this.savedTemplate.arabicMessage = template.arabic_message
            this.savedTemplate.kurdishMessage = template.kurdish_message

            // Populate all three data objects with the saved template
            this.sendToBranchData.englishMessage = template.english_message
            this.sendToBranchData.arabicMessage = template.arabic_message
            this.sendToBranchData.kurdishMessage = template.kurdish_message

            this.deliverToBranchData.englishMessage = template.english_message
            this.deliverToBranchData.arabicMessage = template.arabic_message
            this.deliverToBranchData.kurdishMessage = template.kurdish_message

            this.sendAllToBranchData.englishMessage = template.english_message
            this.sendAllToBranchData.arabicMessage = template.arabic_message
            this.sendAllToBranchData.kurdishMessage = template.kurdish_message
          }
        })
        .catch((error) => {
          console.error('Error fetching WhatsApp template:', error)
        })
    },

    saveWhatsAppTemplate() {
      const token = localStorage.getItem('access_token')

      // Use the messages from whichever dialog is currently open
      let englishMessage = ''
      let arabicMessage = ''
      let kurdishMessage = ''

      if (this.sendToBranchModal) {
        englishMessage = this.sendToBranchData.englishMessage
        arabicMessage = this.sendToBranchData.arabicMessage
        kurdishMessage = this.sendToBranchData.kurdishMessage
      } else if (this.deliverToBranchModal) {
        englishMessage = this.deliverToBranchData.englishMessage
        arabicMessage = this.deliverToBranchData.arabicMessage
        kurdishMessage = this.deliverToBranchData.kurdishMessage
      } else if (this.sendAllToBranchModal) {
        englishMessage = this.sendAllToBranchData.englishMessage
        arabicMessage = this.sendAllToBranchData.arabicMessage
        kurdishMessage = this.sendAllToBranchData.kurdishMessage
      }

      axios
        .put(
          'api/whatsapp-message-template',
          {
            english_message: englishMessage,
            arabic_message: arabicMessage,
            kurdish_message: kurdishMessage
          },
          { headers: { Authorization: 'Bearer ' + token } }
        )
        .then((response) => {
          if (response.data.success) {
            swal(this.$t('common.success'), this.$t('whatsappTemplate.templateSavedSuccessfully'), 'success')
            this.fetchWhatsAppTemplate()
          }
        })
        .catch((error) => {
          swal(this.$t('common.error'), this.$t('whatsappTemplate.failedToSaveTemplate'), 'error')
          console.error('Error saving WhatsApp template:', error)
        })
    },

    sendAllToPendingToBranch() {
      if (this.qrCodeValues.length < 1) {
        return swal({
          text: this.$t('orders.pleaseAtLeastSelectOneOrder'),
          icon: 'warning',
          dangerMode: true
        })
      }

      this.sendAllToBranchModal = true
    },

    getCompanyData(token) {
      axios
        .get('api/company_info', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.companyData = response.data.data
        })
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    checkDiff(arr) {
      return arr.length !== 0 && new Set(arr).size !== 1
    },

    openGenerateQrCodeModal() {
      if (this.qrCodeValues.length < 1) {
        swal({
          text: this.$t('orders.pleaseAtLeastSelectOneOrder'),
          icon: 'warning',
          dangerMode: true,
        })
      } else {
        this.generateQrCodeModal = true
      }
    },

    closeGenerateQrCodeModal() {
      this.generateQrCodeModal = false
      this.qrCodeValues = []
    },

    generateQrCode() {
      this.closeGenerateQrCodeModal()
    },

    checkAll() {
      this.qrCodeValues = this.apiResults.map(r => [r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID, r.is_ship_only, r.credit, r.product_name])
    },

    unCheckAll() {
      this.qrCodeValues = []
    },

    getOrderID(orders) {
      this.orderID.orders_id = []
      for (let i = 0; i < orders.length; i++) {
        this.orderID.orders_id[i] = orders[i].order_id
      }
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      // A selection made before a filter/search/reload must not silently carry over into
      // the new result set — otherwise a stale row (no longer even visible) stays selected
      // and gets included in the next bulk action, affecting rows the user never intended
      // to touch in the current (filtered) view.
      this.qrCodeValues = []

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }
          this.resultsVersion++

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          this.getOrderID(this.apiResults)
          if (theDatatable) { theDatatable.classList.remove('slide-table-out') }
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch((errors) => { })
    },

    sendToExport() {
      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName

      // Build URL parameters from current table state
      const params = new URLSearchParams({
        searchedOneCol: this.tableData.searchOneCol || '',
        searchedOneVal: this.tableData.searchOneVal || '',
        column: this.tableData.column || 'updated_at',
        sortDir: this.tableData.sortDir || 'desc',
        searchValue: this.tableData.search || '',
        from_date: this.tableData.from_date || '',
        to_date: this.tableData.to_date || '',
        warehouses: localStorage.getItem('warehouse_id_fk') || '',
        per_page: this.tableData.per_page || 10,
        branches_id: this.tableData.branches_id || ''
      })

      window.location.replace(fullHostName + '/api/pending-to-branch-export?' + params.toString())
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.warehouse_id_fk = ''
      this.getResults()
    },

    openSendToBranchModal() {
      this.sendToBranchModal = true
    },

    closeSendToBranchModal() {
      this.sendToBranchModal = false
      this.sendToBranchData.order_id = ''
      // Reset to saved template
      this.sendToBranchData.englishMessage = this.savedTemplate.englishMessage
      this.sendToBranchData.arabicMessage = this.savedTemplate.arabicMessage
      this.sendToBranchData.kurdishMessage = this.savedTemplate.kurdishMessage
      this.$validator.reset()
    },

    resetGetResults2() {
      this.resetGetResults()
    },

    getWarehouses() {
      this.warehouses = []
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id })
          })
        })
        .catch(() => {})
    },

    handleWarehouseFilter(val) {
      this.tableData.warehouse_id_fk = Array.isArray(val) && val.length ? val.join(',') : ''
      this.url = 'api/pending_to_branch_order'
      this.getResults()
    },

    deliverToBranch(order) {
      this.deliverToBranchData.id = order.order_id

      // Use the saved template without customer name and order ID
      this.deliverToBranchData.englishMessage = this.savedTemplate.englishMessage
      this.deliverToBranchData.arabicMessage = this.savedTemplate.arabicMessage
      this.deliverToBranchData.kurdishMessage = this.savedTemplate.kurdishMessage

      this.deliverToBranchModal = true
    },

    sendToBranch() {
      let token = localStorage.getItem('access_token')

      // First, get the order details to append customer info to messages
      if (this.sendToBranchData.send_sms) {
        // Fetch order details by QR code
        axios
          .get(this.orderDetailUrl + '/' + this.sendToBranchData.order_id, {
            headers: { Authorization: 'Bearer ' + token }
          })
          .then((response) => {
            const orderData = response.data.data[0]
            const customerName = orderData.full_name || ''
            const orderId = orderData.theOrderID || ''

            // Append customer name and order ID to the end of each message
            if (!this.sendToBranchData.englishMessage.includes(customerName)) {
              this.sendToBranchData.englishMessage += '\n\nCustomer: ' + customerName + '\nOrder ID: ' + orderId
            }
            if (!this.sendToBranchData.arabicMessage.includes(customerName)) {
              this.sendToBranchData.arabicMessage += '\n\nالعميل: ' + customerName + '\nرقم الطلب: ' + orderId
            }
            if (!this.sendToBranchData.kurdishMessage.includes(customerName)) {
              this.sendToBranchData.kurdishMessage += '\n\nکڕیار: ' + customerName + '\nژمارەی داواکاری: ' + orderId
            }

            // Now send to branch
            this.submitSendToBranch(token)
          })
          .catch(() => {
            swal(this.$t('common.error'), this.$t('orders.couldNotFetchOrderDetails'), 'error')
          })
      } else {
        // Send directly if SMS not enabled
        this.submitSendToBranch(token)
      }
    },

    submitSendToBranch(token) {
      let payload = {
        send_sms: this.sendToBranchData.send_sms
      }

      if (this.sendToBranchData.send_sms) {
        // Generate full concatenated message in frontend
        const fullMessage = this.sendToBranchData.englishMessage + '\n\n---\n\n' + this.sendToBranchData.arabicMessage + '\n\n---\n\n' + this.sendToBranchData.kurdishMessage
        payload.message = fullMessage
      }

      axios
        .put(
          this.deliverToBranchUrl + '/' + this.sendToBranchData.order_id,
          payload,
          {
            headers: { Authorization: 'Bearer ' + token }
          }
        )
        .then((response) => {
          this.sendToBranchData.order_id = ''
          // Reset to generic messages
          this.sendToBranchData.englishMessage = 'Hello,\n\nYour order has arrived in Erbil. Please visit us between 10:00 AM to 5:30 PM except Friday to pick up your goods from Ship Zone warehouse.'
          this.sendToBranchData.arabicMessage = 'مرحبا،\n\nوصل طلبك إلى أربيل. يرجى زيارتنا بين الساعة 10:00 صباحاً إلى 5:30 مساءً باستثناء الجمعة لاستلام بضائعك من مستودع Ship Zone.'
          this.sendToBranchData.kurdishMessage = 'سڵاو\n\nکالات گەیشتووەتە هەولێر. سەردانمان بکە لەنێوان 10:00  تا  5:30 ی ئێوارە جگە لە هەینی بۆ وەرگرتنەوەی کالاکانت لە کۆگای شیپ زۆن.'
          this.closeSendToBranchModal()
          this.getResults()
          swal({
            title: this.$t('common.done'),
            text: '',
            icon: 'success',
            timer: 1500,
            buttons: false
          })
        })
        .catch((error) => {
          this.sendToBranchData.order_id = ''
          // Reset to generic messages
          this.sendToBranchData.englishMessage = 'Hello,\n\nYour order has arrived in Erbil. Please visit us between 10:00 AM to 5:30 PM except Friday to pick up your goods from Ship Zone warehouse.'
          this.sendToBranchData.arabicMessage = 'مرحبا،\n\nوصل طلبك إلى أربيل. يرجى زيارتنا بين الساعة 10:00 صباحاً إلى 5:30 مساءً باستثناء الجمعة لاستلام بضائعك من مستودع Ship Zone.'
          this.sendToBranchData.kurdishMessage = 'سڵاو\n\nکالات گەیشتووەتە هەولێر. سەردانمان بکە لەنێوان 10:00  تا  5:30 ی ئێوارە جگە لە هەینی بۆ وەرگرتنەوەی کالاکانت لە کۆگای شیپ زۆن.'
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
        })
    },

    deliverToBranchSubmit() {
      let token = localStorage.getItem('access_token')

      // First, get the order details to append customer info to messages
      if (this.deliverToBranchData.send_sms) {
        axios
          .get(this.orderDetailUrl + '/' + this.deliverToBranchData.id, {
            headers: { Authorization: 'Bearer ' + token }
          })
          .then((response) => {
            // Generate full concatenated message
            const fullMessage = this.deliverToBranchData.englishMessage + '\n\n---\n\n' + this.deliverToBranchData.arabicMessage + '\n\n---\n\n' + this.deliverToBranchData.kurdishMessage

            let payload = {
              send_sms: this.deliverToBranchData.send_sms,
              message: fullMessage
            }

            // Now send the request
            this.submitDeliverToBranch(token, payload)
          })
          .catch(() => {
            swal(this.$t('common.error'), this.$t('orders.couldNotFetchOrderDetails'), 'error')
          })
      } else {
        // Send directly if SMS not enabled
        let payload = {
          send_sms: this.deliverToBranchData.send_sms
        }
        this.submitDeliverToBranch(token, payload)
      }
    },

    submitDeliverToBranch(token, payload) {
      axios.put(this.deliverToBranchUrl + '/' + this.deliverToBranchData.id, payload, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(() => {
        this.closeDeliverToBranchModal()
        this.getResults()
        swal({
          title: this.$t('common.done'),
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        })
      }).catch(error => {
        this.closeDeliverToBranchModal()
        this.getResults()
        swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
      })
    },

    closeDeliverToBranchModal() {
      this.deliverToBranchModal = false
      this.deliverToBranchData.id = ''
      this.deliverToBranchData.send_sms = true
      // Reset to saved template
      this.deliverToBranchData.englishMessage = this.savedTemplate.englishMessage
      this.deliverToBranchData.arabicMessage = this.savedTemplate.arabicMessage
      this.deliverToBranchData.kurdishMessage = this.savedTemplate.kurdishMessage
    },

    sendAllToBranchSubmit() {
      let orderIds = this.qrCodeValues.map(val => val[0])
      let token = localStorage.getItem('access_token')
      let payload = {
        order_ids: orderIds,
        send_sms: this.sendAllToBranchData.send_sms
      }

      if (this.sendAllToBranchData.send_sms) {
        // Generate full concatenated message template for bulk operations
        const messageTemplate = this.sendAllToBranchData.englishMessage + '\n\n---\n\n' + this.sendAllToBranchData.arabicMessage + '\n\n---\n\n' + this.sendAllToBranchData.kurdishMessage
        payload.message_template = messageTemplate
      }

      axios.put('api/deliver_multiple_order_to_branch', payload, { headers: { Authorization: 'Bearer ' + token } }).then(() => {
        this.closeSendAllToBranchModal()
        this.getResults()
        swal({
          title: this.$t('common.done'),
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        })
      }).catch(error => {
        this.closeSendAllToBranchModal()
        this.getResults()
        swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
      })
    },

    closeSendAllToBranchModal() {
      this.sendAllToBranchModal = false
      this.sendAllToBranchData.send_sms = true
      // Reset to saved template
      this.sendAllToBranchData.englishMessage = this.savedTemplate.englishMessage
      this.sendAllToBranchData.arabicMessage = this.savedTemplate.arabicMessage
      this.sendAllToBranchData.kurdishMessage = this.savedTemplate.kurdishMessage
      this.qrCodeValues = []
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true,
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },
  },
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.buttonPadding {
  padding: 0px !important;
}

/* Mobile order cards: see assets/mobile-order-cards.css */

.customer-name-stack {
  display: inline-flex;
  flex-direction: column;
  vertical-align: middle;
}
.customer-phone-line {
  display: block;
  font-size: 14px;
  color: #666;
}
.combined-cell-td {
  vertical-align: middle;
}
.combined-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  font-size: 15px;
  line-height: 1.4;
  white-space: nowrap;
}
.combined-cell-label {
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/pendingToBranchOrder.vue